export default function DocumentText({ style }) {
  return (
    <svg
      className={style}
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <path
        d='M14.6663 6.66732V10.0007C14.6663 13.334 13.333 14.6673 9.99967 14.6673H5.99967C2.66634 14.6673 1.33301 13.334 1.33301 10.0007V6.00065C1.33301 2.66732 2.66634 1.33398 5.99967 1.33398H9.33301'
        stroke='#8FC045'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.6663 6.66732H11.9997C9.99967 6.66732 9.33301 6.00065 9.33301 4.00065V1.33398L14.6663 6.66732Z'
        stroke='#8FC045'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.66699 8.66602H8.66699'
        stroke='#8FC045'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.66699 11.334H7.33366'
        stroke='#8FC045'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
